import { HashRouter as Router, Routes, Route } from 'react-router-dom'
import { useState, useEffect } from 'react'
import LandingPage from './pages/LandingPage'
import LoginPage from './pages/LoginPage'
import AdminPanel from './pages/AdminPanel'
import Dashboard from './pages/Dashboard'
import './styles/index.css'

function App() {
    const [user, setUser] = useState(null)
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        // Check for existing session
        const token = localStorage.getItem('terramind_token')
        const userData = localStorage.getItem('terramind_user')
        if (token && userData) {
            try {
                setUser(JSON.parse(userData))
            } catch (e) {
                console.error('Error parsing user data:', e)
            }
        }
        setIsLoading(false)
    }, [])

    const handleLogin = (userData, token) => {
        localStorage.setItem('terramind_token', token)
        localStorage.setItem('terramind_user', JSON.stringify(userData))
        setUser(userData)
    }

    const handleLogout = () => {
        localStorage.removeItem('terramind_token')
        localStorage.removeItem('terramind_user')
        setUser(null)
    }

    if (isLoading) {
        return (
            <div className="loading-screen">
                <div className="loading-spinner"></div>
                <p>Cargando TerraMind...</p>
            </div>
        )
    }

    return (
        <Router>
            <Routes>
                <Route path="/" element={
                    user ? <Dashboard user={user} onLogout={handleLogout} /> : <LandingPage />
                } />
                <Route path="/login" element={<LoginPage onLogin={handleLogin} />} />
                <Route path="/admin" element={<AdminPanel />} />
                <Route
                    path="/dashboard/*"
                    element={
                        user ? (
                            <Dashboard user={user} onLogout={handleLogout} />
                        ) : (
                            <LoginPage onLogin={handleLogin} />
                        )
                    }
                />
            </Routes>
        </Router>
    )
}

export default App

